import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'ngx-form-area',
  templateUrl: './form-area.component.html',
  styleUrls: ['./form-area.component.scss'],
})
export class FormAreaComponent implements OnInit {
  @Input() title: string;
  @Input() value: string;
  @Output() valueChange: EventEmitter<string>;

  constructor() {
    this.valueChange = new EventEmitter<string>();
  }

  ngOnInit() {
  }

  updateValue(event) {
    this.valueChange.emit(event);
  }

}
